export const LMS_APP = 'lms';
export const DEVICE_ID_KEY = 'lms.deviceId';

export function isSessionJwt(token: string | null | undefined): boolean {
  return typeof token === 'string' && token.split('.').length === 3;
}

export function getOrCreateDeviceId(): string {
  const existing = localStorage.getItem(DEVICE_ID_KEY)?.trim();
  if (existing) {
    return existing;
  }
  const id = crypto.randomUUID();
  localStorage.setItem(DEVICE_ID_KEY, id);
  return id;
}

export function isAccessTokenExpired(token: string | null | undefined): boolean {
  if (!isSessionJwt(token)) {
    return true;
  }
  try {
    const payload = JSON.parse(
      atob(token!.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')),
    ) as { exp?: number };
    if (!payload.exp) {
      return false;
    }
    return payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
}
